(function () {
  const initAnimation = (section) => {
    if (
      !section ||
      !section.classList.contains("social-media-section") ||
      !section.querySelector(".animate-on-scroll")
    )
      return;

    const text = section.querySelector(".social-media-content__main-text");
    if (!text) return;

    ScrollTrigger.create({
      trigger: text,
      start: "50% 95%",
      end: "bottom top",
      onEnter: () => text.classList.add("animated"),
    });
  };

  const initSlider = (section) => {
    if (!section || !section.classList.contains("social-media-section"))
      return;

    const slider = section.querySelector(".social-media-slider");
    if (!slider) return;

    const speed =
      window.innerWidth >= 750
        ? Number(slider.dataset.speed) * 1000
        : (Number(slider.dataset.speed) - 4) * 1000;
    const slidesPerView = Number(slider.dataset.slidesPerView) || 1;

    const swiper = new Swiper(slider, {
      loop: true,
      allowTouchMove: false,
      spaceBetween: window.innerWidth < 750 ? 48 : 48,
      speed: speed,
      slidesPerView: slidesPerView,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      breakpoints: {
        0: { spaceBetween: 48, slidesPerView: slidesPerView },
        750: {
          spaceBetween: 48,
          slidesPerView: slidesPerView - 2 <= 0 ? 2 : slidesPerView - 2,
        },
        990: {
          spaceBetween: 48,
          slidesPerView: slidesPerView - 1 <= 0 ? 2 : slidesPerView - 1,
        },
        1360: { spaceBetween: 48, slidesPerView: slidesPerView },
      },
    });

    // Removed pause-on-hover logic to keep continuous sliding behavior.
  };

  const addRichTextLinksArrows = (section) => {
    if (!section || !section.classList.contains("social-media-section"))
      return;

    const richTextLinks = section.querySelectorAll(
      ".social-media-content__main-text a"
    );
    if (!richTextLinks.length) return;

    const richTextArrow =
      '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 28.4848L28.4821 4M28.4821 4H6.49748M28.4821 4V25.9846" stroke="#7B7F84" stroke-width="2" stroke-linecap="square"/></svg>';

    richTextLinks.forEach((link) => {
      if (link.querySelector(".social-media-content__main-text-arrows")) return;

      link.dataset.label = link.textContent;

      const arrowWrapper = document.createElement("span");
      arrowWrapper.classList.add("social-media-content__main-text-arrows");
      arrowWrapper.innerHTML =
        '<span class="social-media-content__main-text-arrows-wrapper">' +
        richTextArrow +
        richTextArrow +
        "</span>";

      link.appendChild(arrowWrapper);
    });
  };

  const section = document.currentScript.parentElement;

  addRichTextLinksArrows(section);
  initSlider(section);
  initAnimation(section);

  document.addEventListener("shopify:section:load", (event) => {
    addRichTextLinksArrows(event.target);
    initSlider(event.target);
    initAnimation(event.target);
  });
})();
